import { render, staticRenderFns } from "./ManageKanbanStatusesPage.vue?vue&type=template&id=2f8e40b0&scoped=true"
import script from "./ManageKanbanStatusesPage.vue?vue&type=script&lang=ts"
export * from "./ManageKanbanStatusesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8e40b0",
  null
  
)

export default component.exports